export const SCREENS = {
  welcome: { src: "/brand/screen-onboarding.webp", name: "Welcome", label: "Pitchally app — welcome screen: build your music career beyond the stream" },
  opportunities: { src: "/brand/screen-opportunities.webp", name: "Opportunities", label: "Pitchally app — opportunities feed with playlist and campaign briefs" },
  analytics: { src: "/brand/screen-analytics.webp", name: "Analytics", label: "Pitchally app — streaming analytics screen" },
};
